// react
import { useContext, useState } from 'react';

// types
import { Component } from '../../../@types';

// context
import { ContextProject } from '../../pages/Project/Project.context';

// hooks
import { useFetch } from '../../../hooks/useFetch';

// fields
import { Select, SelectProps } from '../Select/Select';

// props extended from SelectProps
export interface SelectComponentProps extends SelectProps {
	excludedComponents?: number[];
}

export const SelectComponent = ({ excludedComponents, ...props }: SelectComponentProps) => {
	// session
	const accessToken = sessionStorage.getItem('accessToken');
	const idToken = sessionStorage.getItem('idToken');

	// context
	const { project } = useContext(ContextProject);

	// state
	const [components, setComponents] = useState<Component[]>([]);

	// fetch component
	useFetch({
		isEnabled: Boolean(project?.id),
		url: `${process.env.REACT_APP_API_URL}/components?project=${project?.id}&fields=id,name&status=ACTIVE&orderBy=name&order=ASC`,
		options: {
			headers: {
				Authorization: `Bearer ${accessToken}`,
				User: String(idToken),
			},
		},
		onSuccess: (res) => {
			if (res.data) {
				setComponents(res.data);
			}
		},
	});

	const optionsComponent = components
		.filter((component) => !excludedComponents || !excludedComponents.includes(component.id))
		.map((component) => {
			return {
				label: component.name,
				MenuItemProps: {
					resource: component,
				},
				value: String(component.id),
			};
		});

	return <Select name="component" {...props} options={optionsComponent} />;
};
